import { ErrorState } from './types/reducerTypes'
import { AnyAction } from 'redux'

const defaultState: ErrorState = {
  error: {
    status: null,
    code: null,
    content: {},
    codeBaseLocation: '',
    errorType: '',
  },
}

export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'TRIGGER_ERROR':
      return { ...state, ...action.payload }
    default:
      return state
  }
}
